// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2VOwt","header":"ReportDetails_header__1t3fA","title":"ReportDetails_title__3j9vD","left":"ReportDetails_left__14taH"};